import styled from 'styled-components'

import { FireButton } from '@nx/fire/button'
import { Body, Label } from '@nx/fire/typography'

export const StyledToastContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border-radius: 5px;
  border-left: 1px solid ${({ theme }) => theme.colours.status.error};
  padding: 14px;
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledLabel = styled(Label)`
  padding: 3px 7px;
  color: ${({ theme }) => theme.colours.status.error};
  background: rgb(201 0 0 / 10%);
  font-size: 10px;
  line-height: 20px;
  border-radius: 5px;
  ${({ theme }) => theme.fontStyles.sourceSans.medium}
  align-self: flex-start;
`

export const StyledMessage = styled(Body)`
  line-height: 1.5;
  color: ${({ theme }) => theme.colours.primary.black};
  margin: 5px 0 0;
  ${({ theme }) => theme.fontStyles.sourceSans.regular}
`

export const StyledCloseButton = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 42px;
  padding: 12px;
  pointer-events: auto;
  position: absolute;
  right: 0;
  top: 24px;
  transform: translateY(-50%);
  width: 42px;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colours.primary.primary};
  }

  svg {
    width: 100%;
    height: 100%;
  }
`

export const StyledIncreaseBid = styled(FireButton)`
  height: 24px;
  justify-content: flex-start;
  ${({ theme }) => theme.fontStyles.sourceSans.bold}
`
